import { defineStore } from "pinia";
import { ref } from "vue";

export const useAiBannerStore = defineStore("aiBanner", () => {
  const hasNewContent = ref<boolean>(false);

  return {
    hasNewContent,
  };
});
